import React from "react";
import PsFieldError from "./PsFieldError";

export default function PsCheckbox({ input, label, meta, placeholder }) {
  return (
    <div>
      <PsFieldError meta={meta} />
      <div className="checkbox">
        <label>
          <input {...input} type="checkbox" value={true} checked={input.value} />
          {label}
        </label>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/PsCheckbox.js